export default __webpack_public_path__ + "assets/images/b11d99d56b0b36e17b83ba47502869a8.jpeg";